import { Languages } from 'lucide-react'
import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isEnglishTestRoute, setLanguage, useLanguage } from '@/lib/i18n'
import './language.css'

export function LanguageToggle() {
  const language = useLanguage()
  const { pathname } = useLocation()
  const exam = isEnglishTestRoute(pathname)
  useLayoutEffect(() => {
    document.documentElement.lang = exam ? 'en' : language
    document.documentElement.dir = !exam && language === 'ar' ? 'rtl' : 'ltr'
  }, [language, exam])

  if (exam) return null
  return (
    <button type="button" className="language-toggle" lang={language === 'en' ? 'ar' : 'en'}
      aria-label={language === 'en' ? 'التبديل إلى العربية' : 'Switch to English'}
      onClick={() => setLanguage(language === 'en' ? 'ar' : 'en')}>
      <Languages size={16} aria-hidden="true" /> {language === 'en' ? 'العربية' : 'English'}
    </button>
  )
}
